import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Button} from '../../../shared/components/button';
import {Html} from '../../../shared/components/html';
import {Modal} from '../../../shared/components/modal/modal';
import {Text} from '../../../shared/components/text';
import {dateFormats} from '../../../shared/constants/date';
import {datePipe} from '../../../shared/pipes';
import {MixedTextToHtmlOnly} from '../../../shared/utils/text';
import {Screens} from '../../../shared/routing';
import {IStateProps} from './model';
import useStyles from './style';
import {showDetailsButton} from '../../../shared/utils/showDetailsButton';

export default ({onModalClose, onNotificationPress, notification, navigation}: IStateProps) => {
  const requestIdfromNotificationText = (notificationText: string | undefined): RegExpMatchArray | undefined => {
    if (notificationText === undefined) return;
    const notificationTypeCheck = /(Ваше обращение №(\d+) зарегистрировано)/gm;
    const regExpReqNum = /\d+/g;
    if (notificationText.search(notificationTypeCheck) > -1) {
      return notificationText.match(regExpReqNum)!;
    }
  };
  const id: RegExpMatchArray | undefined = requestIdfromNotificationText(notification?.text);
  const handlePress = () => {
    navigation.navigate(Screens.SupportService);
    if (id !== undefined) {
      setTimeout(() => {
        navigation.navigate(Screens.SupportServiceTopics, {
          id: id[0] || '',
        });
      });
    }
  };

  const styles = useStyles();
  if (!notification) return null;

  const referenceType = notification.referenceType ? notification.referenceType : '';
  let isShowing: boolean;
  if (showDetailsButton(referenceType) && !id) {
    isShowing = true;
  } else {
    isShowing = false;
  }

  return (
    <Modal
      onClose={onModalClose}
      title={notification.topic}
      wrapStyle={styles.container}
      contentStyle={styles.content}
      titleStyle={styles.title}>
      <View testID='notification-body'>
        <Html
          content={MixedTextToHtmlOnly(notification.text)}
          testID='topic-request-text'
          style={StyleSheet.flatten(styles.bodyText)}
        />
      </View>
      {isShowing && onNotificationPress ? (
        <View style={styles.buttonWrap}>
          <Button
            id='notifications-description'
            style={styles.button}
            type='secondary'
            text='Подробнее'
            onPress={onNotificationPress}
          />
        </View>
      ) : null}
      {requestIdfromNotificationText(notification.text) !== undefined ? (
        <View style={styles.buttonWrap}>
          <Button
            id='notifications-description'
            style={styles.button}
            type='secondary'
            text='Подробнее'
            onPress={handlePress}
          />
        </View>
      ) : null}
      <Text style={styles.time} testID='notification-date'>
        {datePipe(notification.dateTime, dateFormats.fullDateWithTime)}
      </Text>
    </Modal>
  );
};
